import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container,Image} from "react-bootstrap";
import Founder from "../../../assests/images/founder_image.webp";
import {
     AboutSection,
     AboutText,
     AboutTitle,
     AboutSmallText,
     AboutList,
     AboutItem,
     NeedSection,
     NeedTitle,
     FounderNeed,
     FounderImage,
     FounderText,
     FounderSmallText,
     FounderDesignation,
     OpportunitySection,
} from './ladyFreethinkerStyle';
import { useDispatch, useSelector } from "react-redux";
import { elliottAdvocacyHandler } from "../../../redux/slices/elliottAdvocacy/elliott-advocacy";
import { MESSAGE } from "../../../utils/message";
import { AdvocacyTitle, ElliottAdvocacyBanner } from "../../../components/common/commonSubPageBanner/commonSubPageBannerStyle";

const LadyFreethinker = () => {
     const dispatch:any = useDispatch();
     const PersonInfo = useSelector((state:any) => state?.elliottAdvocacy?.data)
  
     useEffect(() => {
        dispatch(elliottAdvocacyHandler())
     }, [])
     return (
          <>
               <ElliottAdvocacyBanner className="elliott-advocacy-banner">
                    <Container className="cont-w">
                         <AdvocacyTitle className='title-sub-page'> Elliott Advocacy Help More Consumers with GreatNonprofits</AdvocacyTitle>
                    </Container>
               </ElliottAdvocacyBanner>
               
               <AboutSection>
                    <Container className="cont-w">
                         <AboutText>
                              <AboutTitle>About</AboutTitle>
                              <AboutSmallText>Elliott Advocacy is a 501(c)(3) nonprofit organization that empowers consumers to solve their problems and helps those who can’t. It provides direct advocacy services on behalf of consumers free of charge, for cases where:</AboutSmallText>
                              <AboutList>
                                   <AboutItem>
                                        A company hasn’t fulfilled its contractual obligation to provide a product or service.
                                   </AboutItem>
                                   <AboutItem>
                                        All efforts to go through normal resolution channels have been exhausted.
                                   </AboutItem>
                                   <AboutItem>
                                        The advocacy team believes it can successfully mediate a resolution.
                                   </AboutItem>
                              </AboutList>
                              <AboutSmallText>Elliott Advocacy also offers resources and extensive consumer guides on topics ranging from product returns to travel advice, giving people the tools they need to advocate for themselves.</AboutSmallText>
                         </AboutText>
                         <NeedSection>
                              <NeedTitle>The Need</NeedTitle>
                              <AboutSmallText>{MESSAGE.theNeed}</AboutSmallText>
                              <FounderNeed>
                                   <FounderImage>
                                        <Image src={Founder} alt="Founder" />
                                   </FounderImage>
                                   <FounderText>
                                     <FounderSmallText>{PersonInfo?.data?.theNeed?.quote}</FounderSmallText>
                                     <FounderDesignation>{PersonInfo?.data?.theNeed?.personName}</FounderDesignation>
                                   </FounderText>
                              </FounderNeed>
                         </NeedSection>
                         <OpportunitySection>
                              <NeedTitle>The Opportunity</NeedTitle>
                              <AboutSmallText>{MESSAGE.theOpportunity}</AboutSmallText>
                         </OpportunitySection>
                         <OpportunitySection>
                              <NeedTitle>The Outcome</NeedTitle>
                              <AboutSmallText>{MESSAGE.theOutcome}</AboutSmallText>
                         </OpportunitySection>
                    </Container>
               </AboutSection>
          </>
     )
};
export default LadyFreethinker;